function _instanceof(left, right) {
    "@swc/helpers - instanceof";
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
import { textWidth } from "@d3plus/dom";
import defaultSplit from "./textSplit.js";
var softHyphen = "\u00AD";
/**
    Coerces value into a String.
    @param value The value to convert to a string.
    @private
*/ function stringify(value) {
    if (value === void 0) return "undefined";
    if (typeof value === "string" || _instanceof(value, String)) return value;
    return JSON.stringify(value);
}
/**
    Based on the defined styles and dimensions, breaks a string into an array of strings for each line of text.
*/ export default function() {
    var fontFamily = "sans-serif", fontSize = 10, fontWeight = 400, height = 200, lineHeight, maxLines = null, overflow = false, split = defaultSplit, width = 200;
    /**
      The inner return object and wraps the text and returns the line data array.
      @private
*/ function textWrap(phrase) {
        var sentence = stringify(phrase);
        if (lineHeight === void 0) lineHeight = Math.ceil(fontSize * 1.4);
        var words = split(sentence);
        var style = {
            "font-family": fontFamily,
            "font-size": fontSize,
            "font-weight": fontWeight,
            "line-height": lineHeight
        };
        var line = 1, textProg = "", truncated = false, widthProg = 0;
        var lineData = [], sizes = textWidth(words, style);
        for(var i = 0; i < words.length; i++){
            var word = words[i];
            var wordWidth = sizes[words.indexOf(word)];
            // newline if breaking character or not enough width
            if (textProg.slice(-1) === "\n" || widthProg + wordWidth > width) {
                if (!i && !overflow) {
                    truncated = true;
                    break;
                }
                if (lineData.length >= line) {
                    var lineText = lineData[line - 1].trimEnd();
                    // Convert trailing soft hyphen to visible hyphen at line breaks
                    if (lineText.endsWith(softHyphen)) lineText = lineText.slice(0, -1) + "-";
                    lineData[line - 1] = lineText;
                }
                line++;
                if (lineHeight * line > height || wordWidth > width && !overflow || maxLines && line > maxLines) {
                    truncated = true;
                    break;
                }
                widthProg = 0;
                lineData.push(word);
            } else if (!i) lineData[0] = word;
            else {
                // Strip soft hyphen when syllables stay on the same line
                if (lineData[line - 1].endsWith(softHyphen)) {
                    lineData[line - 1] = lineData[line - 1].slice(0, -1);
                }
                lineData[line - 1] += word;
            }
            textProg += word;
            widthProg += wordWidth;
        }
        // Clean remaining soft hyphens from all lines
        var lines = lineData.map(function(l) {
            return l.replaceAll(softHyphen, "");
        });
        return {
            lines: lines,
            sentence: sentence,
            truncated: truncated,
            widths: textWidth(lines, style),
            words: words
        };
    }
    /**
      The font family used for text measurement.
*/ textWrap.fontFamily = function(_) {
        return arguments.length ? (fontFamily = _, textWrap) : fontFamily;
    };
    /**
      The font size in pixels used for text measurement.
*/ textWrap.fontSize = function(_) {
        return arguments.length ? (fontSize = _, textWrap) : fontSize;
    };
    /**
      The font weight used for text measurement.
*/ textWrap.fontWeight = function(_) {
        return arguments.length ? (fontWeight = _, textWrap) : fontWeight;
    };
    /**
      Maximum height in pixels for the wrapped text.
*/ textWrap.height = function(_) {
        return arguments.length ? (height = _, textWrap) : height;
    };
    /**
      The line height in pixels. Defaults to 1.1 times the [font size](#textWrap.fontSize).
*/ textWrap.lineHeight = function(_) {
        return arguments.length ? (lineHeight = _, textWrap) : lineHeight;
    };
    /**
      Maximum number of lines allowed when wrapping.
*/ textWrap.maxLines = function(_) {
        return arguments.length ? (maxLines = _, textWrap) : maxLines;
    };
    /**
      Whether text is allowed to overflow its bounding box.
*/ textWrap.overflow = function(_) {
        return arguments.length ? (overflow = _, textWrap) : overflow;
    };
    /**
      The function used to split text into words.
*/ textWrap.split = function(_) {
        return arguments.length ? (split = _, textWrap) : split;
    };
    /**
      Maximum width in pixels for the wrapped text.
*/ textWrap.width = function(_) {
        return arguments.length ? (width = _, textWrap) : width;
    };
    return textWrap;
}

//# sourceMappingURL=textWrap.js.map